import * as actionTypes from 'modules/audits/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {boolean} AuditDashboardIsCreationModalOpenReducer
 */
const initialState = false;

const isOpen = () => true;

const isClose = () => false;

export default createReducer(initialState, {
  [actionTypes.OPEN_CREATION]: isOpen,
  [actionTypes.CLOSE_CREATION]: isClose,
  [actionTypes.POST_SUCCESS]: isClose,
  [LOCATION_CHANGE]: isClose,
});
